/**
 * Created with IntelliJ IDEA.
 * User: Gerald
 * Date: 14.06.12
 * Time: 15:13
 * To change this template use File | Settings | File Templates.
 */

import { IAssetManager } from "./IAssetManager";
import { DefaultAssetManager } from "./DefaultAssetManager";

export class AssetManager {

    private static _manager: IAssetManager;

    public static get manager(): IAssetManager {
        if (AssetManager._manager == null) {
            AssetManager._manager = new DefaultAssetManager();
        }

        return AssetManager._manager;
    }

    public static set manager(value: IAssetManager) {
        AssetManager._manager = value;
    }
}
